import { Helpers } from '../../helpers';
import { IUnitOfMeasure } from '../../interfaces/iunit-of-measure';
import { AssetThirdPartyConstraint } from '../asset-third-party-constraint';
import { CompletionsRentalUnitCost } from '../completions-rental-unit-cost';
import { DirectionalCost } from '../directional-cost';
import { DrillingCost } from '../drilling-cost';
import { FuelRate } from '../fuel-rate';
import { FundingCategoryAssembly } from '../funding-category-assembly';
import { HorsePowerRate } from '../horse-power-rate';
import { Item } from '../item';
import { ItemCapacity } from '../item-capacity';
import { LocationDirtworkCost } from '../location-dirtwork-cost';
import { MudLoggingCost } from '../mud-logging-cost';
import { OpenHoleLoggingCost } from '../open-hole-logging-cost';
import { ProjectCostCodeCostTypeItem } from '../project-cost-code-cost-type-item';
import { ProjectCostCodeCostTypeItemsRevision } from '../project-cost-code-cost-type-items-revision';
import { ProjectResourceItem } from '../project-resource-item';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';
import { RigCost } from '../rig-cost';
import { StimUnitRate } from '../stim-unit-rate';
import { TotalLandDamage } from '../total-land-damage';
import { WaterAreaCost } from '../water-area-cost';
import { WellheadCost } from '../wellhead-cost';

export class UnitOfMeasureBase {
  UnitOfMeasureId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetThirdPartyConstraints_UnitOfMeasure?: Array<AssetThirdPartyConstraint> | null;
  CompletionsRentalUnitCosts_UnitOfMeasure?: Array<CompletionsRentalUnitCost> | null;
  DirectionalCosts_UnitOfMeasure?: Array<DirectionalCost> | null;
  DrillingCosts_UnitOfMeasure?: Array<DrillingCost> | null;
  FuelRates_UnitOfMeasure?: Array<FuelRate> | null;
  FundingCategoryAssemblies_UnitOfMeasure?: Array<FundingCategoryAssembly> | null;
  HorsePowerRates_UnitOfMeasure?: Array<HorsePowerRate> | null;
  LocationDirtworkCosts_UnitOfMeasure?: Array<LocationDirtworkCost> | null;
  MudLoggingCosts_UnitOfMeasure?: Array<MudLoggingCost> | null;
  OpenHoleLoggingCosts_UnitOfMeasure?: Array<OpenHoleLoggingCost> | null;
  ProjectCostCodeCostTypeItems_UnitOfMeasure?: Array<ProjectCostCodeCostTypeItem> | null;
  ProjectCostCodeCostTypeItemsRevisions_UnitOfMeasure?: Array<ProjectCostCodeCostTypeItemsRevision> | null;
  ProjectResourceItems_UnitOfMeasure?: Array<ProjectResourceItem> | null;
  ProjectResourceItemsRevisions_UnitOfMeasure?: Array<ProjectResourceItemsRevision> | null;
  RigCosts_UnitOfMeasure?: Array<RigCost> | null;
  StimUnitRates_UnitOfMeasure?: Array<StimUnitRate> | null;
  TotalLandDamages_UnitOfMeasure?: Array<TotalLandDamage> | null;
  WaterAreaCosts_UnitOfMeasure?: Array<WaterAreaCost> | null;
  WellheadCosts_UnitOfMeasure?: Array<WellheadCost> | null;
  ItemCapacities_GasCapacityUnitOfMeasure?: Array<ItemCapacity> | null;
  ItemCapacities_OilCapacityUnitOfMeasure?: Array<ItemCapacity> | null;
  ItemCapacities_WaterCapacityUnitOfMeasure?: Array<ItemCapacity> | null;
  Items_PrimaryUOM?: Array<Item> | null;

  constructor(item?: IUnitOfMeasure) {
    if (item) {

      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetThirdPartyConstraints_UnitOfMeasure = Helpers.createClassArray(AssetThirdPartyConstraint, item.AssetThirdPartyConstraints_UnitOfMeasure);
      this.CompletionsRentalUnitCosts_UnitOfMeasure = Helpers.createClassArray(CompletionsRentalUnitCost, item.CompletionsRentalUnitCosts_UnitOfMeasure);
      this.DirectionalCosts_UnitOfMeasure = Helpers.createClassArray(DirectionalCost, item.DirectionalCosts_UnitOfMeasure);
      this.DrillingCosts_UnitOfMeasure = Helpers.createClassArray(DrillingCost, item.DrillingCosts_UnitOfMeasure);
      this.FuelRates_UnitOfMeasure = Helpers.createClassArray(FuelRate, item.FuelRates_UnitOfMeasure);
      this.FundingCategoryAssemblies_UnitOfMeasure = Helpers.createClassArray(FundingCategoryAssembly, item.FundingCategoryAssemblies_UnitOfMeasure);
      this.HorsePowerRates_UnitOfMeasure = Helpers.createClassArray(HorsePowerRate, item.HorsePowerRates_UnitOfMeasure);
      this.LocationDirtworkCosts_UnitOfMeasure = Helpers.createClassArray(LocationDirtworkCost, item.LocationDirtworkCosts_UnitOfMeasure);
      this.MudLoggingCosts_UnitOfMeasure = Helpers.createClassArray(MudLoggingCost, item.MudLoggingCosts_UnitOfMeasure);
      this.OpenHoleLoggingCosts_UnitOfMeasure = Helpers.createClassArray(OpenHoleLoggingCost, item.OpenHoleLoggingCosts_UnitOfMeasure);
      this.ProjectCostCodeCostTypeItems_UnitOfMeasure = Helpers.createClassArray(ProjectCostCodeCostTypeItem, item.ProjectCostCodeCostTypeItems_UnitOfMeasure);
      this.ProjectCostCodeCostTypeItemsRevisions_UnitOfMeasure = Helpers.createClassArray(ProjectCostCodeCostTypeItemsRevision, item.ProjectCostCodeCostTypeItemsRevisions_UnitOfMeasure);
      this.ProjectResourceItems_UnitOfMeasure = Helpers.createClassArray(ProjectResourceItem, item.ProjectResourceItems_UnitOfMeasure);
      this.ProjectResourceItemsRevisions_UnitOfMeasure = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_UnitOfMeasure);
      this.RigCosts_UnitOfMeasure = Helpers.createClassArray(RigCost, item.RigCosts_UnitOfMeasure);
      this.StimUnitRates_UnitOfMeasure = Helpers.createClassArray(StimUnitRate, item.StimUnitRates_UnitOfMeasure);
      this.TotalLandDamages_UnitOfMeasure = Helpers.createClassArray(TotalLandDamage, item.TotalLandDamages_UnitOfMeasure);
      this.WaterAreaCosts_UnitOfMeasure = Helpers.createClassArray(WaterAreaCost, item.WaterAreaCosts_UnitOfMeasure);
      this.WellheadCosts_UnitOfMeasure = Helpers.createClassArray(WellheadCost, item.WellheadCosts_UnitOfMeasure);
      this.ItemCapacities_GasCapacityUnitOfMeasure = Helpers.createClassArray(ItemCapacity, item.ItemCapacities_GasCapacityUnitOfMeasure);
      this.ItemCapacities_OilCapacityUnitOfMeasure = Helpers.createClassArray(ItemCapacity, item.ItemCapacities_OilCapacityUnitOfMeasure);
      this.ItemCapacities_WaterCapacityUnitOfMeasure = Helpers.createClassArray(ItemCapacity, item.ItemCapacities_WaterCapacityUnitOfMeasure);
      this.Items_PrimaryUOM = Helpers.createClassArray(Item, item.Items_PrimaryUOM);
    }
  }
}